import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '@/lib/supabase';
import { useSiteSettings } from '@/hooks/useSiteSettings';

export default function ConsultWidget() {
  const { t } = useTranslation();
  const { wechat_qr_url, whatsapp_qr_url, contact } = useSiteSettings();
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<'wechat' | 'whatsapp'>('wechat');
  const [visible, setVisible] = useState(false);

  // Build clean WhatsApp number (strip non-digits)
  const whatsappClean = contact.whatsapp.replace(/[^0-9]/g, '');
  const whatsappLink = `https://wa.me/${whatsappClean}`;

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(!open)}
        className={`fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#c9a96e] text-white flex items-center justify-center shadow-lg hover:bg-[#b8944f] transition-all cursor-pointer ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
      >
        <i className={`text-xl ${open ? 'ri-close-line' : 'ri-customer-service-2-line'}`}></i>
      </button>

      {/* Panel */}
      {open && (
        <div className="fixed bottom-24 right-6 z-40 w-72 bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="bg-[#1a3a5c] px-5 py-4">
            <h3 className="text-white font-bold text-sm">{t('nav_consult')}</h3>
            <p className="text-white/60 text-xs mt-0.5">{t('appt_form_contact_soon')}</p>
          </div>
          <div className="p-4">
            {/* Tabs */}
            <div className="flex gap-2 mb-3">
              <button
                onClick={() => setTab('wechat')}
                className={`flex-1 py-2 rounded-xl text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${tab === 'wechat' ? 'bg-[#07c160]/10 text-[#07c160]' : 'bg-gray-100 text-gray-500'}`}
              >
                <i className="ri-wechat-line mr-1"></i>微信
              </button>
              <button
                onClick={() => setTab('whatsapp')}
                className={`flex-1 py-2 rounded-xl text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${tab === 'whatsapp' ? 'bg-[#25d366]/10 text-[#25d366]' : 'bg-gray-100 text-gray-500'}`}
              >
                <i className="ri-whatsapp-line mr-1"></i>WhatsApp
              </button>
            </div>

            {/* QR */}
            <div className="w-full aspect-square rounded-xl overflow-hidden border border-gray-100 mb-3">
              <img
                src={tab === 'wechat' ? wechat_qr_url : whatsapp_qr_url}
                alt={tab === 'wechat' ? 'WeChat QR' : 'WhatsApp QR'}
                className="w-full h-full object-contain"
              />
            </div>

            <a
              href={tab === 'wechat' ? '#' : whatsappLink}
              target={tab === 'whatsapp' ? '_blank' : undefined}
              rel={tab === 'whatsapp' ? 'nofollow noopener noreferrer' : undefined}
              className="block text-center py-2.5 rounded-full bg-[#c9a96e] text-white text-sm font-medium hover:bg-[#b8944f] transition-colors cursor-pointer whitespace-nowrap"
            >
              {tab === 'wechat' ? `微信号：${contact.wechat}` : 'WhatsApp'}
            </a>
          </div>
        </div>
      )}
    </>
  );
}